<template>
  <v-btn
    class="px-2"
    :height="dataHeight"
    :width="dataWidth"
    dark
    color="#0D1117"
    @click="loginWithGithub"
  >
    <div class="full-width d-flex justify-md-space-between">
      <img
        class="v-icon"
        :style="iconStyle"
        :src="require('@/assets/images/icons/socialmedia/github/github-tile.svg')"
      >
      <div class="flex-grow-1 d-flex justify-center align-center">
        <span class="font-weight-bold text-subtitle-1">
          {{ $t('components.AtGithubLoginAtom.text') }}
        </span>
      </div>
    </div>
  </v-btn>
</template>

<script>
import { PortalUtils } from '@/utils/PortalUtils.js'
export default {
  name: 'AtGithubLoginAtom',
  props: {
    redirectUri: {
      type: String,
      default: process.env.VUE_APP_LEARNING + 'Login/GITHUB' // Use learn portal as default domain
    },
    dataHeight: {
      type: String,
      default: '40'
    },
    dataWidth: {
      type: String,
      default: '300'
    },
    iconStyle: {
      type: Object,
      default: () => ({
        padding: '5px',
        height: '36px',
        width: '36px'
      })
    }
  },
  methods: {
    loginWithGithub () {
      const api = process.env.VUE_APP_GITHUB_API_URL
      const url = new URL(this.redirectUri)
      if (this.$route.query.next) {
        url.searchParams.set('next', this.$route.query.next)
      } else {
        // Redirect to current portal
        url.searchParams.set('portal', PortalUtils.name)
      }
      const query = new URLSearchParams({
        client_id: process.env.VUE_APP_GITHUB_CLIENT_ID,
        redirect_uri: url.toString()
      })
      // localStorage.setItem('redirect', window.location.pathname + window.location.search)
      window.location = api + '?' + query
    }
  }
}
</script>
